// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__WWGCK","buttonContainer":"Tabs_buttonContainer__H24ny","tab":"Tabs_tab__TkpxT","active":"Tabs_active__oKN89"};